import { checkRangeByKeys, getRangeByKeys } from '../../ui-kit/Calculator/rangeHelpers.js';
import { useBusinessDepositRates } from './useBusinessDepositRates.js';
const BUSINESS_MIN_DAYS = 1;
const BUSINESS_MAX_DAYS = 1095;
const BUSINESS_RATE_MIN_DAYS = 30; // порог количества дней, при которых ставка не доступна
const BUSINESS_OPERATING_MIN_DAYS = 90;
const BUSINESS_OPERATING_MAX_DAYS = 730;
export const DEFAULT_BUSINESS_DEPOSIT_CALCULATOR_PARAMS = {
    minSum: 1000,
    maxSum: 100000001,
    minDays: BUSINESS_MIN_DAYS,
    maxDays: BUSINESS_MAX_DAYS,
    rate: 0,
    isMonthlyInterestPayment: true,
    isReplenished: false,
    isPartialWithdrawal: false,
    depositeName: "Депозит 'Стабильный'",
};
export const useBusinessDepositParams = (userInputParams, rateParams) => {
    const { daysValue, moneyValue, isPartialWithdrawal, isReplenished, isMonthlyInterestPayment } = userInputParams;
    const isOperatingDeposit = isReplenished || isPartialWithdrawal;
    const isDisabledOperatingDeposit = daysValue < BUSINESS_OPERATING_MIN_DAYS || daysValue > BUSINESS_OPERATING_MAX_DAYS;
    const rateRows = useBusinessDepositRates(rateParams);
    if (daysValue <= BUSINESS_RATE_MIN_DAYS) {
        return {
            ...DEFAULT_BUSINESS_DEPOSIT_CALCULATOR_PARAMS,
            ...userInputParams,
            isDisabledOperatingDeposit,
            isUnavailableByTerm: true,
        };
    }
    const businessDepositCalculatorSourceBookParams = rateRows?.find((_) => {
        return (isMonthlyInterestPayment === _.isMonthlyInterestPayment &&
            checkIsOperatingDeposit(isOperatingDeposit, _) &&
            checkRangeByKeys(moneyValue, ['minSum', 'maxSum'], _) &&
            checkRangeByKeys(daysValue, ['minDays', 'maxDays'], _));
    }) || DEFAULT_BUSINESS_DEPOSIT_CALCULATOR_PARAMS;
    const { rate } = businessDepositCalculatorSourceBookParams;
    const income = getDepositIncome(rate, userInputParams);
    const finalSum = moneyValue + income;
    const sourceBookRows = rateRows || [DEFAULT_BUSINESS_DEPOSIT_CALCULATOR_PARAMS];
    return {
        ...businessDepositCalculatorSourceBookParams,
        ...getRangeByKeys(['minSum', 'maxSum'], sourceBookRows),
        ...getRangeByKeys(['minDays', 'maxDays'], sourceBookRows),
        ...userInputParams,
        isDisabledOperatingDeposit,
        income,
        finalSum,
    };
};
const checkIsOperatingDeposit = (isOperatingDeposit, sourceBookRow) => isOperatingDeposit
    ? sourceBookRow.isReplenished && sourceBookRow.isPartialWithdrawal
    : !sourceBookRow.isReplenished && !sourceBookRow.isPartialWithdrawal;
const getDepositIncome = (rate, userInputParams) => {
    const { isMonthlyInterestPayment, moneyValue, daysValue } = userInputParams;
    /*
    Приблизительный расчёт, не учитывающий разницу в количестве дней в месяцах. Месяц принят за 30 дней, год за 365 дней.
    */
    if (isMonthlyInterestPayment) {
        return Math.round(moneyValue * Math.pow((1200 + rate) / 1200, daysValue / 30) - moneyValue);
    }
    else {
        return Math.round((moneyValue * rate * daysValue) / 365 / 100);
    }
};
//# sourceMappingURL=useBusinessDepositParams.js.map